import React from 'react';

const PlatformAvailabilitySection: React.FC = () => {
    return (
        <section style={{
            background: '#F7F7F7',
            padding: '120px 24px',
        }}>
            <div style={{
                maxWidth: '800px',
                margin: '0 auto',
                textAlign: 'center',
            }}>
                {/* Pill label */}
                <div style={{
                    display: 'inline-block',
                    padding: '6px 16px',
                    background: '#7C3AED',
                    borderRadius: '100px',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: '#FFFFFF',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: '24px',
                }}>
                    Available Everywhere
                </div>

                <h2 style={{
                    fontSize: 'clamp(32px, 5vw, 48px)',
                    fontWeight: 500,
                    color: '#000000',
                    marginBottom: '16px',
                    letterSpacing: '-0.02em',
                }}>
                    Use it on any device
                </h2>

                <p style={{
                    fontSize: '18px',
                    color: '#333333',
                    marginBottom: '48px',
                }}>
                    Same experience on iOS and web
                </p>

                {/* Device icons */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '64px',
                    alignItems: 'flex-end',
                    marginBottom: '48px',
                    flexWrap: 'wrap',
                }}>
                    {/* Phone icon */}
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            width: '80px',
                            height: '140px',
                            border: '2px solid #000000',
                            borderRadius: '16px',
                            margin: '0 auto 16px',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            {/* Notch */}
                            <div style={{
                                position: 'absolute',
                                top: '8px',
                                width: '30px',
                                height: '4px',
                                background: '#000000',
                                borderRadius: '2px',
                            }} />
                            {/* Screen content */}
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="1.5">
                                <polyline points="20,6 9,17 4,12" />
                            </svg>
                            {/* Home indicator */}
                            <div style={{
                                position: 'absolute',
                                bottom: '6px',
                                width: '32px',
                                height: '3px',
                                background: '#000000',
                                borderRadius: '2px',
                            }} />
                        </div>
                        <div style={{
                            fontSize: '15px',
                            fontWeight: 600,
                            color: '#000000',
                        }}>
                            iOS App
                        </div>
                    </div>

                    {/* Laptop icon */}
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            width: '160px',
                            height: '110px',
                            border: '2px solid #000000',
                            borderRadius: '8px 8px 0 0',
                            margin: '0 auto',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="1.5">
                                <polyline points="20,6 9,17 4,12" />
                            </svg>
                        </div>
                        {/* Laptop base */}
                        <div style={{
                            width: '180px',
                            height: '10px',
                            background: '#000000',
                            borderRadius: '0 0 4px 4px',
                            margin: '0 auto 16px',
                        }} />
                        <div style={{
                            fontSize: '15px',
                            fontWeight: 600,
                            color: '#000000',
                        }}>
                            Web App
                        </div>
                    </div>
                </div>

                <a
                    href="https://apps.apple.com/jp/app/vibe-commenting/id6760636999?l=en-US"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'inline-block',
                        padding: '12px 24px',
                        background: '#000000',
                        color: '#FFFFFF',
                        borderRadius: '8px',
                        border: 'none',
                        fontSize: '15px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        textDecoration: 'none',
                    }}
                >
                    Download on the App Store
                </a>
            </div>
        </section>
    );
};

export default PlatformAvailabilitySection;
